<template>
  <div id="app">
    <Selector
      @click="showResults = true"
      :class="{ hidden: showResults }"
      @change="filterChanged"
      :result-count="filteredProducts.length"
      :total-count="products.length"
    />

    <Results
      :class="{ hidden: !showResults }"
      @click="showResults = false"
      :products="filteredProducts"
    ></Results>
  </div>
</template>

<script>
import Selector from "./components/Selector.vue";
import Results from "./components/Results.vue";
import { Config, Labels, Utils, DataLayer } from "./services";

export default {
  name: "App",
  components: {
    Selector,
    Results,
  },
  data() {
    return {
      showResults: false,
      resultCount: 0,
      products: [],
      filteredProducts: [],
    };
  },
  created() {
    Config.init();
    Labels.init();
    DataLayer.getProducts()
      .then((results) => {
        this.products = this.processProducts(results.data || []);
        this.filteredProducts = this.products;
      })
      .catch((err) => {
        Utils.showStatusMessage(`Cannot read products. ${err.message}.`);
      })
      .finally(() => {});
  },
  methods: {
    filterChanged(filters) {
      this.filteredProducts = this.applyFilters(filters);
    },
    applyFilters(filters) {
      if (!this.products) return [];
      if (!filters) return this.products;
      let ret = [];
      this.products.map((p) => {
        let add = true;
        filters.options.map((opt) => {
          if (p.attributes.indexOf(opt) === -1) {
            add = false;
          }
        });
        if (add) ret.push(p);
      });
      return ret;
    },
    sortProducts(products) {
      products.sort((a, b) =>
        parseInt(a["Product Ranking"]) > parseInt(b["Product Ranking"]) ? 1 : -1
      );
      return products;
    },
    processProducts(products) {
      let ret = [];
      products.map((p) => {
        let newProduct = { attributes: [] };
        for (let prop in p) {
          if (p.hasOwnProperty(prop)) {
            if (p[prop] === "Y") {
              newProduct.attributes.push(prop);
            } else if (p[prop] !== "N") {
              newProduct[prop] = p[prop];
            }
          }
        }
        ret.push(newProduct);
      });
      return this.sortProducts(ret);
    },
  },
};
</script>

<style>
#app {
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #232323;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  position: relative;
}

.cla-messagebox {
  position: fixed;
  top: 100px;
  right: 0;
  background-color: #ffffff;
  max-width: 400px;
  padding: 20px;
  font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
  box-shadow: 3px 3px rgba(200, 200, 200, 0.4);
  border-left: 1px solid #e4e4e4;
  animation: slide 0.5s forwards;
  transition: opacity 500ms linear;
  opacity: 1;
  z-index: 10001;
}

@keyframes slide {
  0% {
    right: 0;
  }
  100% {
    right: 100px;
  }
}

.cla-messagebox.green {
  border-top: 3px solid green;
}

.cla-messagebox.yellow {
  border-top: 3px solid yellow;
}

.cla-messagebox.red {
  border-top: 3px solid red;
}

.loader {
  width: 64px;
  height: 64px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg class='lds-spinner' width='64px' height='64px' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 100 100' preserveAspectRatio='xMidYMid' style='background: none;'%3E%3Cg transform='rotate(0 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.9166666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(30 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.8333333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(60 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.75s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(90 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.6666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(120 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5833333333333334s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(150 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.5s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(180 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.4166666666666667s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(210 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.3333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(240 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.25s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(270 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.16666666666666666s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(300 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='-0.08333333333333333s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3Cg transform='rotate(330 50 50)'%3E%3Crect x='47' y='24' rx='9.4' ry='4.8' width='6' height='12' fill='%233498DB'%3E%3Canimate attributeName='opacity' values='1;0' keyTimes='0;1' dur='1s' begin='0s' repeatCount='indefinite'%3E%3C/animate%3E%3C/rect%3E%3C/g%3E%3C/svg%3E");
  margin: auto;
}

.loader.top {
  top: 80px;
  bottom: unset;
}

.spacer {
  flex-grow: 1;
}

.hidden {
  display: none;
}
</style>
